// Function to  return a field in a nested object using a string
// e.g.: extract the field (targetField) from an object (obj) using the input string: "obj.layer1.layer2.targetField"
function resolveObj(targetString, obj) {
  var targetStringTemp;
  var targetStringSplit = [];
  var a;
  var b; // Split initially by entries made using the dot notation e.g.: var1.var2

  targetStringTemp = targetString === null || targetString === void 0 ? void 0 : targetString.split(".");

  for (var ii = 0; ii < targetStringTemp.length; ii++) {
    // Now also split by entries made using square bracket notation e.g.: var1[var2]
    if (targetStringTemp[ii].includes("[")) {
      a = targetStringTemp[ii].split("[");
      b = a[1].split("]")[0];
      targetStringSplit.push(a[0]);
      targetStringSplit.push(b[0]);
    } else {
      targetStringSplit.push(targetStringTemp[ii]);
    }
  } // Evaluate the nested object chain


  return targetStringSplit.reduce(function (prev, curr) {
    return prev ? prev[curr] : null;
  }, obj);
} // Function to  return a field in a nested object using a string
// This is the exact same as resolveObj with the excpetion that this funciton will create the nested object should it not already exist
// e.g.: extract the field (targetField) from an object (obj) using the input string: "obj.layer1.layer2.targetField"

function resolveOrCreateObj(obj, targetString, defaultValue) {
  var targetStringTemp;
  var targetStringSplit = [];
  var a;
  var b; // Split initially by entries made using the dot notation e.g.: var1.var2

  targetStringTemp = targetString === null || targetString === void 0 ? void 0 : targetString.split(".");

  for (var ii = 0; ii < targetStringTemp.length; ii++) {
    // Now also split by entries made using square bracket notation e.g.: var1[var2]
    if (targetStringTemp[ii].includes("[")) {
      a = targetStringTemp[ii].split("[");
      b = a[1].split("]")[0];
      targetStringSplit.push(a[0]);
      targetStringSplit.push(b[0]);
    } else {
      targetStringSplit.push(targetStringTemp[ii]);
    }
  } // Evaluate the nested object chain


  return targetStringSplit.reduce(function (prev, curr, currentIndex, array) {
    var _prev$curr;

    return prev ? (_prev$curr = prev[curr]) !== null && _prev$curr !== void 0 ? _prev$curr : prev[curr] = currentIndex === array.length - 1 ? defaultValue !== undefined ? defaultValue : {} : {} : null;
  }, obj);
} // Function to  return the base object name from a string representing a nested object
// e.g.: extract the base object name ("obj") from a nested object string: "obj.layer1.layer2.targetField"

function baseObjStr(objString) {
  if (!objString.includes(".")) {
    return objString;
  } else {
    return objString.slice(0, objString.indexOf("."));
  }
} // Find the object matching a certain key in an array of objects

function listContainsObject(list, keyName, value) {
  var i;

  for (i = 0; i < (list === null || list === void 0 ? void 0 : list.length); i++) {
    if (JSON.stringify(resolveObj(keyName, list[i])) === JSON.stringify(value)) {
      return {
        object: list[i],
        index: i
      };
    }
  }

  return false;
} // Find an array of objects all matching a certain key in an array of objects

function listContainsMultipleObjects(list, keyName, value) {
  var i;
  var returnList = [];

  for (i = 0; i < (list === null || list === void 0 ? void 0 : list.length); i++) {
    if (JSON.stringify(list[i][keyName]) === JSON.stringify(value)) {
      returnList.push(list[i]);
    }
  }

  return returnList;
}

export { baseObjStr, listContainsMultipleObjects, listContainsObject, resolveObj, resolveOrCreateObj };
